export const SET_MODELES = 'SET_MODELES'
export const TOGGLE_MODELE_SELECTION = 'TOGGLE_MODELE_SELECTION'
export const RESET_CURRENT_MODELE = 'RESET_CURRENT_MODELE'
export const SET_MODELES_LOADING = 'SET_MODELES_LOADING'
export const SET_MODELES_PAGE = 'SET_MODELES_PAGE'
export const SET_INCLUDE_ARTICLES = 'SET_INCLUDE_ARTICLES'

